export function indexOf(array, item) {
  for (var i = 0; i < array.length; i++) {
    if (array[i] === item) { return i; }
  }
  return -1;
}


//////////////////
// WEBPACK FOOTER
// ./~/tiny-slider/bower_components/go-native/src/gn/indexOf.js
// module id = 40
// module chunks = 0